import React from 'react';
import { Layout, Typography } from 'antd';
import { companyInfo } from '../data/mockData';

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

const Footer = () => {
  return (
    <AntFooter style={{ 
      background: '#101828', 
      color: 'white',
      padding: '40px 20px',
      textAlign: 'center'
    }}>
      <Text style={{ color: '#98A2B3' }}>
        {companyInfo.name}. 保留所有权利。
      </Text>
    </AntFooter>
  );
};

export default Footer;